var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_VideoFile_36dp",
    "data-name": "Icon/VideoFile/36dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aspect_ratio-black-36dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H36V36H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M30,30H6a3,3,0,0,1-3-3V9A3,3,0,0,1,6,6H30a3,3,0,0,1,3,3V27A3,3,0,0,1,30,30ZM15,11.818a1,1,0,0,0-1,1V23.18a1,1,0,0,0,1.54.84l8.14-5.18A.989.989,0,0,0,24.145,18a1.006,1.006,0,0,0-.465-.854l-8.14-5.17A1,1,0,0,0,15,11.818Z",
    fill: "#ff5427"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/VIDEO.0a38557fea36d7c4a346a9dd1c1980cc.svg";
export { ForwardRef as ReactComponent };